// **********************************************************************
// ******** Agenda do profissional e serviço oferecido pelo Prestador ***
// ******** app/PrestadorProfile/agendamento.jsx
// ******** autor: WdePaula / Microvolution
// ******** data: 15/07/24 | 19h37
// ******** data: 20/10/24w | 11h23 | acrescentado nome e endereço do estabelecimento
// ******** data: 24/10/24w | 11h19 | eliminamos a poluição visual
// ******** data: 12/11/24w | 14h52 | acrescentamos o recebimento da variável "intervaloAtendimento" que vem do servidor (vr entre 30 e 120 minutos)
// ******** data: 04/10/25w | 14h20 | modificamos o handleSave na tentativa de resolver o problema do "ocorreu um erro inesperado" - claude.ia
// ******** Agenda do profissional e serviço oferecido pelo Prestador ***
// **********************************************************************




import React, { useState, useEffect, useRef } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Icon from '@mdi/react';
import { mdiArrowLeftCircle } from '@mdi/js';
import apiaxios from '../../../../Services/apiaxios.js';
import handleApiError from '../../../../Services/apiErrorHandler.js';
import CardCalendario from '../../components/Calendario/calendario.jsx';
import CardHorarios from '../../components/Calendario/horarios.jsx';
import CardUserInputModal from '../../components/Agendamentos/userinputmodal.jsx';
import DownloadAppModal from '../../components/Agendamentos/modaldownload.jsx'
import imgLogomarca from '../../../../Assets/agendex/logoagendexcliente.png';
import imgLogoMini from '../../../../Assets/agendex/iconLogoAgendex.png';
import Footer from '../../components/Footer/footer.jsx';

import './profissionalagendamento.css';
import { Spinner } from 'react-bootstrap';

function Agendamento () {
    const { state } = useLocation();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const { linkpersonalizado, id, profId, servId } = useParams();
    // const [vINTERVALOAGENDA, setVINTERVALOAGENDA] = useState(60); // Default value
    const [horarios, setHorarios] = useState([]);
    const [fotoPerfil, setFotoPerfil] = useState(state?.fotoPerfil || null);
    const [profissionalNome, setProfissionalNome] = useState(state?.profissionalNome || null);
    const [empresaNome, setEmpresaNome] = useState(state?.nomeEmpresa || null);
    const [empresaEndereco, setEmpresaEndereco] = useState(state?.enderecoEmpresa || null);
    const [empresaCelular, setEmpresaCelular] = useState(state?.celularEmpresa || null);
    const [servicoNome, setServicoNome] = useState(state?.servicoNome || null);
    const [servicoValor, setServicoValor] =  useState(state?.servicoValor || null);
    // console.log('servicoValor ', servicoValor);
    const [vINTERVALOAGENDA, setVINTERVALOAGENDA] = useState(state?.intervaloAtendimento || 60);

    const [servicoDataHora, setServicoDataHora] = useState(null);
    const [selectedHorario, setSelectedHorario] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [celular, setCelular] = useState('');
    const [nome, setNome] = useState('');
    const [obs, setObs] = useState('');
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [resId, setResId] = useState(0);

    const [loadingHorarios, setLoadingHorarios] = useState(false);

    const horariosRef = useRef(null);  // Ref para a seção de horários
    const navigate = useNavigate();

    // verifica se é mobile, tablet, nb, pc, etc
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);

        // DEBUG
        // console.log('📱 empresaCelular:', empresaCelular);
        // // console.log('📱 whatsappNumber:', whatsappNumber);
        // console.log('📱 Dados completos:', {
        //     empresaCelular,
        //     profissionalNome,
        //     servicoNome,
        //     // nomeCliente,
        //     servicoDataHora,
        //     selectedHorario
        // });
        
        // // if (empresaCelular && whatsappNumber) {
        // if (empresaCelular) {
        //     // console.log('✅ Vai abrir WhatsApp!');
        //     // handleEnviarAgendamentoViaWhats();
        //     // alert('vai emviar mensagem no zap');
        // } else {
        //     // console.log('❌ NÃO vai abrir WhatsApp - falta dados');
        // }

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Monitoramos `selectedHorario` para atualizar `servicoDataHora` quando ele mudar
    useEffect(() => {
        if (selectedHorario) {
            setServicoDataHora(selectedHorario.DATA_HORA);
        }
    }, [selectedHorario]); // Este efeito é executado sempre que `selectedHorario` mudar

    // busca os horários disponíveis do colaborador selecionado, que serve para qq serviço q foi selecionado
    const fetchHorarios = (date) => {
        if (!date) return; // Evita requisições desnecessárias se a data for nula

        const formattedDate = date.toISOString().split('T')[0];
        // setServicoData(formattedDate);
        const endpoint = `/servico/HorarioColaboradorDiarioWeb`;

        const params = {
            id_empresa: id,
            id_colaborador: profId,
            dt: formattedDate,
            tempoAgendaMinutos: vINTERVALOAGENDA
        };
        
        setHorarios([]);
        setLoadingHorarios(true);
        apiaxios.get(endpoint, { params })
            .then(response => {
                setHorarios([]);
                const horariosDisponiveis = response.data.map(item => ({
                    ...item,
                    selected: false,
                    label: item.label || item.HORA // Assegurar que existe uma propriedade para exibição
                }));
                setHorarios(horariosDisponiveis);
                horariosRef.current.scrollIntoView({ behavior: 'smooth' });  // Scroll para a seção de horários
            })
            .catch(error => {
                handleApiError(error);
                // console.error(error);
                setHorarios([]);
            })
            .finally( e => {
                setLoadingHorarios(false);
            })
    };

    const handleSelectDate = (date) => {
        fetchHorarios(date);
        setSelectedHorario(null); // limpa o horário selecionado e oculta o botão "Confirmar Agendamento"
        // horariosRef.current.scrollIntoView({ behavior: 'smooth' });  // Scroll para a seção de horários
    };

    const onSelectHorario = async (horaSelecionada) => {
        const updatedHorarios = horarios.map(hora => ({
            ...hora,
            selected: hora.HORA === horaSelecionada.HORA
        }));
        setHorarios(updatedHorarios);
        setSelectedHorario(horaSelecionada);
    };

    // Função para formatar a data
    const formatarData = (data) => {
        const partes = data.split('/');
        return `${partes[2]}/${partes[1]}/${partes[0]}`;
    };

    // pede confirmação do usuário para realizar agendamento... se sim, verifica se agenda da empresa não está fechada e agenda o serviço. antes pega os 2 dados do usuário

    // const onConfirmaAgendamento = () => {
    //     if (!selectedHorario) {
    //         Swal.fire('Erro', 'Você precisa marcar um dia e horário para confirmar agendamento', 'error');
    //         return;
    //     }

    //     Swal.fire({
    //         title: 'Confirmação!',
    //         text: `Você confirma este agendamento no Agendex Cliente Web?`,
    //         icon: 'question',
    //         showCancelButton: true,
    //         confirmButtonColor: '#3085d6',
    //         cancelButtonColor: '#d33',
    //         confirmButtonText: 'Sim, agendar!',
    //         cancelButtonText: 'Cancelar'
    //       }).then((result) => {
    //         if (result.isConfirmed) {
    //             const checkAgendaFechada = async () => {
    //                 try {
    //                     alert('agendafechadafetch');
    //                     const response = await apiaxios.get('/Empresa/AgendaFechadaWeb', {
    //                         params: { id_usuario: id }
    //                     });
        
    //                     if (response.status === 200) {
    //                         const data = response.data;
    //                         if (data.retorno !== 'OK') {
    //                             Swal.fire('Erro', data.retorno, 'error');
    //                             return false;
    //                         }
        
    //                         const agendaFechada = data.agenda_fechada === null ? 0 : data.agenda_fechada;

    //                         if (agendaFechada === 1) {
    //                             Swal.fire('Empresa com Agenda fechada temporariamente!', '', 'info');
    //                             return false;
    //                         }
    //                         return true;
    //                     } else {
    //                         Swal.fire('Erro', 'Falha ao verificar o status da agenda do profissional escolhido. Tente novamente mais tarde.', 'error');
    //                         return false;
    //                     }
    //                 } catch (error) {
    //                     Swal.fire('Erro', 'Erro ao verificar o status da agenda: ' + error.message, 'error');
    //                     return false;
    //                 }
    //             };
    //             setShowModal(true); // removido 20/7/24w 13h18 // voltei 20/7/24w 13h28
    //         }
    //       });
    // };

    const onConfirmaAgendamento = async () => {
        if (!selectedHorario) {
            Swal.fire('Erro', 'Você precisa marcar um dia e horário para confirmar agendamento', 'error');
            return;
        }
    
        const result = await Swal.fire({
            title: 'Confirmação!',
            text: `Você confirma este agendamento no Agendex Cliente Web?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, agendar!',
            cancelButtonText: 'Cancelar'
        });
    
        if (result.isConfirmed) {
            const checkAgendaFechada = async () => {
                try {
                    // console.log('agendafechadafetch');
                    const response = await apiaxios.get('/empresaLink/EmpresaAgendaFechadaWeb', {
                        params: { id_usuario: id }
                    });
    
                    if (response.status === 200) {
                        const data = response.data;
                        // console.log('response dada: ', data);
                        if (data.retorno !== 'OK') {
                            Swal.fire('Erro', data.retorno, 'error');
                            return false;
                        }
    
                        const agendaFechada = Number(data.agenda_fechada === null ? 0 : data.agenda_fechada);
                        // console.log('agendaFechada ', agendaFechada);
                        if (agendaFechada === 1) {
                            Swal.fire('Empresa com Agenda fechada temporariamente!', '', 'info');
                            return false;
                        }
                        return true;
                    } else {
                        Swal.fire('Erro', 'Falha ao verificar o status da agenda do profissional escolhido. Tente novamente mais tarde.', 'error');
                        return false;
                    }
                } catch (error) {
                    Swal.fire('Erro', 'Erro ao verificar o status da agenda: ' + error.message, 'error');
                    return false;
                }
            };
    
            // Aguarda a verificação da agenda antes de executar o próximo passo
            const isAgendaAberta = await checkAgendaFechada();
            // console.log('isAgendaAberta ', isAgendaAberta);
            if (isAgendaAberta) {
                setShowModal(true); // Só será executado se a agenda não estiver fechada
            }
        }
    };
    
    // voltar uma página
    const handleBackClick = () => {
        navigate(-1); // Navegar para a página anterior
    };

    const handleClose = () => {
        setShowModal(false);
    };
    
    // const handleSave = (data) => {
    //     const clienteNome = data.nome;
    //     const clienteFone = data.celular;
    //     setCelular(data.celular);
    //     setNome(data.nome);
    //     setObs(data.obs);
    
    //     setShowModal(false);
    //     const agendarServico = async () => {
    //         const dataFormatada = formatarData(selectedHorario.DATA);

    //         try {
    //             console.log('handleSave tudo: ', id, servId, profId, dataFormatada, selectedHorario.label, data);
    //             // const response = await apiaxios.post('/servico/agendarColaboradorWeb', {
    //             const response = await apiaxios.post('/empresaLink/servicoAgendarColaboradorWeb', {
    //                 id_usuario: id, // Supondo que `id_usuario` seria por hora o do prestador`
    //                 id_servico: servId,
    //                 id_empresa: id,
    //                 id_colaborador: profId,
    //                 dt: dataFormatada, // Usando a data formatada
    //                 hora: selectedHorario.label,
    //                 id_status: 1,
    //                 agenda_avulso_nome: data.nome,
    //                 agenda_avulso_fone: data.celular,
    //                 agenda_avulso_obs: data.obs
    //             });

    //             if (response.status === 201) {
    //                 const data = response.data;
    //                 if (data.retorno === 'OK') {
    //                     Swal.fire('Sucesso', `Agendamento nº ${data.id_reserva} realizado com sucesso!`, 'success').then(() => {
    //                         setResId(data.id_reserva);
    //                         // console.log('reserva id dentro do swal: ', data.id_reserva);
    //                         console.log('"data" dentro do swal: ', data);
    //                         handleAgendamentoSuccess(
    //                             selectedHorario.label,
    //                             selectedHorario.DATA,
    //                             clienteNome,
    //                             clienteFone,
    //                             data.id_reserva
    //                         );
    //                     });
    //                 } else {
    //                     Swal.fire('Erro', data.retorno, 'error');
    //                 }
    //             } else {
    //                 Swal.fire('Erro', 'Falha ao confirmar agendamento. Tente novamente mais tarde.', 'error');
    //             }
    //         } catch (error) {
    //             if (error.response) {
    //                 const data = error.response;
    //                 const message = data.retorno || data.message || 'Ocorreu um erro inesperado.';
    //                 Swal.fire('Erro', 'Erro ao confirmar agendamento: ' + message, 'error');
    //             } else {
    //                 // Erro de rede ou outra falha
    //                  Swal.fire('Erro', 'Não foi possível conectar ao servidor. Por favor, verifique sua conexão com a internet.', 'error');
    //             }
            
    //             // console.log('catch error ', error);
    //         }
    //     };
    //     agendarServico();
    // }

    const handleSave = (data) => {
        const clienteNome = data.nome;
        const clienteFone = data.celular;
        setCelular(data.celular);
        setNome(data.nome);
        setObs(data.obs);

        setShowModal(false);
        const agendarServico = async () => {
            const dataFormatada = formatarData(selectedHorario.DATA);

            try {
                // console.log('handleSave tudo: ', id, servId, profId, dataFormatada, selectedHorario.label, data);
                const response = await apiaxios.post('/empresaLink/servicoAgendarColaboradorWeb', {
                    id_usuario: id,
                    id_servico: servId,
                    id_empresa: id,
                    id_colaborador: profId,
                    dt: dataFormatada,
                    hora: selectedHorario.label,
                    id_status: 1,
                    agenda_avulso_nome: data.nome,
                    agenda_avulso_fone: data.celular,
                    agenda_avulso_obs: data.obs
                });

                if (response.status === 201) {
                    const responseData = response.data;
                    if (responseData.retorno === 'OK') {
                        Swal.fire('Sucesso', `Agendamento nº ${responseData.id_reserva} realizado com sucesso!`, 'success').then(() => {
                            setResId(responseData.id_reserva);
                            // console.log('"responseData" dentro do swal: ', responseData);
                            handleAgendamentoSuccess(
                                selectedHorario.label,
                                selectedHorario.DATA,
                                clienteNome,
                                clienteFone,
                                responseData.id_reserva
                            );
                        });
                    } else {
                        Swal.fire('Erro', responseData.retorno, 'error');
                    }
                } else {
                    Swal.fire('Erro', 'Falha ao confirmar agendamento. Tente novamente mais tarde.', 'error');
                }
            } catch (error) {
                console.error('Erro completo:', error);
                
                if (error.response && error.response.data) {
                    // Servidor respondeu com erro
                    const errorData = error.response.data;
                    const message = errorData.retorno || errorData.message || 'Ocorreu um erro inesperado.';
                    Swal.fire('Erro', 'Erro ao confirmar agendamento: ' + message, 'error');
                } else if (error.request) {
                    // Requisição foi feita mas sem resposta
                    Swal.fire('Erro', 'Não foi possível conectar ao servidor. Por favor, verifique sua conexão com a internet.', 'error');
                } else {
                    // Outro tipo de erro
                    Swal.fire('Erro', 'Ocorreu um erro inesperado: ' + error.message, 'error');
                }
            }
        };
        agendarServico();
    }

    const handleAgendamentoSuccess = (servicoHorario, servicoData, nomeCliente, celularCliente, reservaId) => {
        // console.log('handleAgendamentoSuccess clienteNome ', nomeCliente);
        // console.log('handleAgendamentoSuccess clienteFone ', celularCliente);
        // console.log('resid: ', resId);
        // console.log('reserva id: ', reservaId);
        // console.log('serviço valor dentro de handleAgendamentoSuccess: ', servicoValor);
        setShowDownloadModal(true);
        // navigate(`/agendar/${linkpersonalizado}/${id}/profissional/${profId}/servico/${servId}/agendamento/${resId}`, {
        navigate(`/agendar/${linkpersonalizado}/${id}/profissional/${profId}/servico/${servId}/agendamento/${reservaId}`, {
            state: { 
                empresaNome, 
                empresaEndereco, 
                empresaCelular,
                profissionalNome, 
                fotoPerfil, 
                servicoNome, 
                servicoHorario, 
                servicoData, 
                servicoValor,
                nomeCliente, 
                celularCliente,
            }
        });
    };



    return (
        <>
            <div className="container-fluid">
                <div className="row flex-nowrap">
                    <div className="col py-3 me-3 main-content">
                        <div className="text-center">
                            <button className="btn btn-secondary back-button position-fixed top-0 start-0 m-3" onClick={handleBackClick}>
                                <Icon path={mdiArrowLeftCircle} size={1}/> {!isMobile && 'Voltar'}
                            </button>
                            <img src={isMobile ? imgLogoMini : imgLogomarca} className={`img-logo ${isMobile ? 'img-logo-mobile' : 'img-logo-desktop'}`} alt="logo agendex"/>
                            <br/>

                            {fotoPerfil ? (
                                <div className='text-center'>
                                    <img src={fotoPerfil} alt="Imagem de capa do Prestador" className='usuario-foto'/>
                                </div>
                            ) : (
                                <p>{empresaNome}</p>                                        
                            )}

                            <br/> <br/>
                            <h1>Agendando um horário com: {profissionalNome}</h1>
                        </div>
                        <hr />
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className='box-detalhe-agenda'>
                                <CardCalendario onSelectDate={handleSelectDate} />
                                <hr />
                            </div>
                        </div> 
                        
                        <div ref={horariosRef} className="box-colaboradores">
                            {loadingHorarios ? (
                                <div className="text-center">
                                    <Spinner animation="border" role="status">
                                        <span className="visually-hidden">Carregando...</span>
                                    </Spinner>
                                </div>
                                ) : (
                                    <CardHorarios horarios={horarios} onSelectHorario={onSelectHorario}/>
                            )}
                        <hr />
                            <br />
                            <div className="text-center">
                                <button 
                                    type="button" 
                                    className="btn btn-success"
                                    disabled={!selectedHorario} // Botão desativado enquanto não há horário selecionado
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title='O dia/horário acima foi selecionado. Clique para confirmar seu agendamento!'
                                    onClick={() => onConfirmaAgendamento()}
                                >
                                    Confirmar Agendamento
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>

            <div>
                {/* <button onClick={onConfirmaAgendamento}></button> */}
                {/* {console.log(servicoValor, servicoValor)} */}
                {/* {servicoValor === 0 ? 
                    (
                        setServicoValor = ('Valor a combinar')
                    ) : (
                        setServicoValor = (servicoValor)
                    )
                } */}

                <CardUserInputModal
                    show={showModal}
                    onHide={handleClose}
                    handleSave={handleSave}
                    celular={celular}
                    setCelular={setCelular}
                    nome={nome}
                    setNome={setNome}
                    obs={obs}
                    setObs={setObs}
                    profissionalNome={profissionalNome}
                    servicoNome={servicoNome}
                    servicoValor={servicoValor}
                    servicoDataHora={servicoDataHora}
                />
            </div>
            <div>
                <DownloadAppModal
                    show={showDownloadModal}
                    onHide={() => setShowDownloadModal(false)}
                />
            </div>
        </>
    );
}

export default Agendamento;